import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { FileUpload } from '../../../File'
import Text from '../../../Text'

import * as styles from './FormActionsAttachContainer.module.css'

function FormActionsAttachContainer({
  children,
  className,
  isDragging,
  isOver,
  uploadProps,
  onDragLeave,
  onDragOver,
}) {
  const { t } = useTranslation()

  const containerClassName = classNames(className, {
    [styles.containerDragging]: isDragging,
  })

  const draggingClassName = classNames(styles.dragging, {
    [styles.over]: isOver,
  })

  const textClassName = classNames({ [styles.text]: isOver })

  return (
    <FileUpload {...uploadProps} openOnClick={false}>
      <div
        className={containerClassName}
        onDragLeaveCapture={onDragLeave}
        onDragOverCapture={onDragOver}
      >
        {children}
        {isDragging ? (
          <div className={styles.draggingWrapper}>
            <div className={draggingClassName}>
              <Text isSecondary className={textClassName}>
                {t('Common.DropAsFileTextKey')}
              </Text>
            </div>
          </div>
        ) : null}
      </div>
    </FileUpload>
  )
}

export default FormActionsAttachContainer
